import {gql} from 'apollo-angular';


export const personalImageGql = gql`
  query ReloadPersonalImageQuery($participantId: [Int!]) {
      Participant (participantId: $participantId){
        participantId
        event {
          eventId
        }
        individualConstituent {
          imagePath
        }
        team {
            teamMembers {
              teamMemberId
              imagePath
              imageId
              email
              fullUrl
              honoree
              onlineFunds
              offlineFunds
              totalFunds (orderBy: DESC)
              facebookFunds
              outstandingMatchingGifts
              outstandingSponsorships
              prefixType {
                name
                cmgmtPrefixTypeId
                description
              }
              teamRoleType {
                description
                teamRoleTypeId
                activeFlag
                name
              }
            }
         
        }
      }
    }
`;